import { createBrowserRouter } from 'react-router-dom';
import { seoRoutes } from '../Components/SeoRoutes/SeoRoutes';
import { services } from '../Components/SeoRoutes/SeoRoutes';

// Home Layouts
import HomeLayout from '../Layouts/HomeLayout';
import About from '../Pages/About';
import ContactPage from '../Pages/ContactPage';
import Home01 from '../Pages/Homes/Home01';
import Projects02 from '../Pages/Projects/Projects02';
import Services02 from '../Pages/Services/Services02';

import ProjectDetails from '../Pages/Projects/ProjectDetails';
import Projects01 from '../Pages/Projects/Projects01';
import ServiceDetails from '../Pages/Services/ServiceDetails';
import Services01 from '../Pages/Services/Services01';
import ErrorPage from '../Pages/ErrorPage/ErrorPage';


const serviceIcons = {
    'costruzione-chiavi-in-mano': {
        icon: '/images/icons/con-helmet.svg',
        whiteIcon: '/images/icons/con-helmet-white.svg'
    },
    'ristrutturazione': {
        icon: '/images/icons/con-hammer-screwdriver.svg',
        whiteIcon: '/images/icons/con-hammer-screwdriver-white.svg'
    },
    'miglioramento-energetico': {
        icon: '/images/icons/con-electricity.svg',
        whiteIcon: '/images/icons/con-electricity-white.svg'
    },
    'servizi-fognature': {
        icon: '/images/icons/con-u-bend.svg',
        whiteIcon: '/images/icons/con-u-bend-white.svg'
    },
    'coperture': {
        icon: '/images/icons/con-level.svg',
        whiteIcon: '/images/icons/con-level-white.svg'
    },
    'sistemazione-esterni': {
        icon: '/images/icons/con-spade-fork.svg',
        whiteIcon: '/images/icons/con-spade-fork-white.svg'
    },
    'movimenti-di-terra': {
        icon: '/images/icons/con-digger.svg',
        whiteIcon: '/images/icons/con-digger-white.svg'
    },
    'piccoli-impianti-civili': {
        icon: '/images/icons/con-screwdrivers.svg',
        whiteIcon: '/images/icons/con-screwdrivers-white.svg'
    },
    'pavimenti-rivestimenti': {
        icon: '/images/icons/con-set-square.svg',
        whiteIcon: '/images/icons/con-set-square-white.svg'
    },
    'pitture': {
        icon: '/images/icons/con-roller.svg',
        whiteIcon: '/images/icons/con-roller-white.svg'
    }
};

export const routes = createBrowserRouter([
    {
        path: "/",
        element: <HomeLayout/>,
        children: [
            {
                path: '/',
                element: <Home01/>
            },
            {
                path: '/chi-siamo',
                element: <About/>
            },
            {
                path: '/contatti',
                element: <ContactPage/>
            },
            {
                path: '*',
                element: <ErrorPage/>
            },
            //{
                //"Costruzione Chiaviami In Mano": "Costruzione Chiaviami In Mano",
            //    "Riustrutturazione": "Riustrutturazione A Z",
            //    "Miglioramento energetico": "Miglioramento energetico",
            //    "Servizi Forgniature": "Servizi Forgniature",
            //    "Coperture": "Coperture",
            //    "Sistimazione Esterni": "Sistimazione Esterni",
            //    "Movimenti Di terra": "Movimenti Di terra",
            //    "Piccoli Impianti Civili": "Piccoli Impianti Civili",
            //    "Pavaimenti e Rivestimenti": "Pavaimenti e Rivestimenti",
            //    "Pitture": "Pitture"
            //
            {
                path: '/costruzione-chiaviami-in-mano',
                element: <Services01/>
            },
            {
                path: '/riustrutturazione',
                element: <Services01/>
            },
            {
                path: '/miglioramento-energetico',
                element: <Services01/>
            },
            {
                path: '/servizi-forgniature',
                element: <Services01/>
            },
            {
                path: '/coperture',
                element: <Services01/>
            },
            {
                path: '/sistimazione-esterni',
                element: <Services01/>
            },
            {
                path: '/movimenti-di-terra',
                element: <Services01/>
            },
            {
                path: '/piccoli-impianti-civili',
                element: <Services01/>
            },
            {
                path: '/contatti',
                element: <ContactPage/>
            },
            {
                path: '/pitture',
                element: <Services01/>
            },
            // Rotte SEO con province
            ...seoRoutes,
            // Aggiungi route base per ogni servizio
            ...Object.values(services).map(service => ({
                path: `/${service.path}`,
                element: <Services01 
                    serviceTitle={service.title}
                    description={service.description}
                    longDescription={service.longDescription}
                    benefits={service.benefits}
                    features={service.features}
                    icon={serviceIcons[service.path]?.icon}
                />
            })),
        ]
    }
])

